import { gossipItems } from "@/mocks/gossip";
import GossipCard from "@/components/feature/GossipCard";
import SectionTitle from "@/components/base/SectionTitle";

export default function LatestFeed() {
  const items = gossipItems.slice(4, 10);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionTitle
        eyebrow="Latest"
        title="最新更新"
        desc="按发布时间倒序整理，刚刚流出的画面会第一时间出现在这里。"
        moreTo="/category"
        moreLabel="查看更多更新"
      />
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {items.map((item) => (
          <GossipCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}